export default "__VITE_ASSET__CasKQZqG__"